export const JOURNEY_CHILD_EVENTS = {
  VIEW_ONBOARDING_KID_FINANCIAL_LITERACY:
    'view_onboarding_kid_financial_literacy',
  SELECT_ONBOARDING_KID_FINANCIAL_LITERACY_CONTINUE:
    'select_onboarding_kid_financial_literacy_continue',
} as const;
